import * as actions from "../actions";
import * as actionsTypes from "../actionTypes";
import {put, takeEvery, all, fork} from "redux-saga/effects";
import ReportService from '../../services/report.service';
import HttpService from './../../services/http.service';
import download from 'js-file-download';

function* getServiceReportList(action) {
  try {
    if (action.payload) {
      const page = action.payload?.pageNo;
      const pageSize = action.payload?.pageSize;
      const service_id = action.payload?.service_id
      const status = action.payload?.statusType

      let params = {page, pageSize, service_id, status};
      const response = yield ReportService.serviceReportList(params);

      if (response?.data?.statusCode === 200) {
        yield put(actions.getServiceReportSuccess(response?.data?.data));
      } else {
        yield put(actions.getServiceReportFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    console.log({error})
    yield put(actions.getServiceReportFailure(error));
  }
}

function* getServiceReportListSaga() {
  yield takeEvery(actionsTypes.GET_SERVICE_REPORT_START, getServiceReportList);
}

function* getLabelServiceReportList(action) {
  try {
    if (action.payload) {
      const page = action.payload?.pageNo;
      const pageSize = action.payload?.pageSize;
      const service_id = action.payload?.service_id;
      const start_date = action.payload?.filterStartDate;
      const end_date = action.payload?.filterEndDate;
      const status = action.payload?.status;
      let params = {page, pageSize, service_id, start_date, end_date,status};

      const response = yield ReportService.labelServiceReportList(params);

      // console.log({response})

      if (response?.data?.statusCode === 200) {
        // console.log('suc')
        yield put(actions.getLabelServiceReportSuccess(response?.data?.data));
      } else {
        yield put(actions.getLabelServiceReportFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    console.log({error})
    yield put(actions.getLabelServiceReportFailure(error));
  }
}

function* getLabelServiceReportListSaga() {
  yield takeEvery(actionsTypes.GET_LABEL_SERVICE_REPORT_START, getLabelServiceReportList);
}


function* getContentReportList(action) {
  try {
    if (action.payload) {
      const page = action.payload?.pageNo;
      const pageSize = action.payload?.pageSize;
      const service_id = action.payload?.service_id
      const start_date = action.payload?.filterStartDate;
      const end_date = action.payload?.filterEndDate;

      let params = {page, pageSize, service_id, start_date, end_date};
      const response = yield ReportService.contentReportList(params);

      // console.log({response})

      if (response?.data?.statusCode === 200) {
        yield put(actions.getContentReportSuccess(response?.data?.data));
      } else {
        yield put(actions.getContentReportFailure("network error"));
      }
    }
  } catch (err) {
    console.log(err)
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    console.log({error})
    yield put(actions.getContentReportFailure(error));
  }
}

function* getContentReportListSaga() {
  yield takeEvery(actionsTypes.GET_CONTENT_REPORT_START, getContentReportList);
}


function* generateReport(action) {
  try {
    const params = action.payload
    console.log("saga type",params);
    var response;
    if (params.role === 0) {
      const data = new FormData()
      data.append('file', params.data.excel_file)
      data.append('data', JSON.stringify(params.serviceData))
      data.append('start_date', params.serviceData.start_date)
      data.append('end_date', params.serviceData.end_date)
      data.append('type', params.type)
      data.append('excel_type', params.serviceData.excel_type)
      data.append('date', params.serviceData.start_date)
      data.append('service_id', params.service_id)
      response = yield ReportService.generateReport(data);
    } else {
      const data = new FormData()
      data.append('file', params.data.excel_file)
      data.append('start_date', params.data.start_date)
      data.append('end_date', params.data.end_date)
      data.append('type', params.type)
      data.append('date', params.data.start_date)
      data.append('excel_type', params.serviceType)
      data.append('service_id', params.service_id)
      response = yield ReportService.contentReport(data);
    }
    if (response?.data.statusCode === 200 || response?.data.statusCode === 201) {
      yield put(actions.generateReportSuccess(response?.data));
    } else {
      yield put(actions.generateReportFailure("no data"));
    }

  } catch (err) {
    let error = err?.response?.data?.message;

    if (!error) {
      error = "network error"
    }

    yield put(actions.generateReportFailure(error));
  }
}

function* generateReportSaga() {
  yield takeEvery(actionsTypes.GENERATE_REPORT_START, generateReport);
}

function* reportLogs(action) {
  try {
    if (action.payload) {
      const response = yield ReportService.reportLogs(action.payload);
      if (response?.data?.statusCode === 200)
        yield put(actions.reportLogsSuccess(response?.data));

      else if(response?.data?.statusCode === 400 || response?.data?.statusCode === 404 || response?.data?.statusCode === 500 )
        yield put(actions.reportLogsFailure("Reports log file error"));

      else
        download(response.data, 'reports-logs.txt')
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) error = 'network error'
    console.log({error})
    yield put(actions.reportLogsFailure(error));
  }
}
function* logsSaga() {
  yield takeEvery(actionsTypes.CLEAR_REPORT_LOGS_START, reportLogs);
}


export function* reportSaga() {
  yield all([
    fork(getServiceReportListSaga),
    fork(generateReportSaga),
    fork(getLabelServiceReportListSaga),
    fork(getContentReportListSaga),
    fork(logsSaga),
  ]);
}
